/**
 * Helper to configure datatransfer for drag & drop operations
 */
import { isDCE } from "@/api";
import { useEventStore } from "@/stores/eventStore";
export function setDrag(evt, data, multiple = false) {
    var _a;
    const eventStore = useEventStore();
    if (data) {
        (_a = evt.dataTransfer) === null || _a === void 0 ? void 0 : _a.setData("text", JSON.stringify([data]));
        // data submitted through datatransfer is only available upon drop,
        // in order to access the drop data immediately this event store is used.
        eventStore.setDragData(data, multiple);
    }
    if (evt.dataTransfer) {
        evt.dataTransfer.dropEffect = "move";
        evt.dataTransfer.effectAllowed = "move";
        const elem = document.getElementById("drag-ghost");
        if (elem) {
            evt.dataTransfer.setDragImage(elem, 0, 0);
        }
    }
}
export function clearDrag() {
    const eventStore = useEventStore();
    eventStore.clearDragData();
}
export function setItemDragstart(item, event, itemIsSelected = false, selectionSize = 0, selectedItems) {
    if (selectedItems && itemIsSelected && selectionSize > 1) {
        const selectedItemsObj = {};
        for (const [key, value] of selectedItems) {
            setCollectionElementName(value);
            selectedItemsObj[key] = value;
        }
        setDrag(event, selectedItemsObj, true);
    }
    else {
        setCollectionElementName(item);
        setDrag(event, item);
    }
}
function setCollectionElementName(obj) {
    if (isDCE(obj)) {
        obj["name"] = obj.element_identifier;
    }
}
